import T from "../theme";
import { HALL } from "../data";
import Reveal from "../components/Reveal";
import { Section, SectionLabel } from "../components/Section";

export default function HallOfFameSection() {
  return (
    <Section id="hall-of-fame" style={{ background: T.bg0 }}>
      <div className="section-pad" style={{ maxWidth: 900, margin: "0 auto" }}>
        <Reveal><SectionLabel text="Hall of Fame" /></Reveal>
        <Reveal delay={0.05}>
          <h2 style={{ color: T.white, fontSize: "clamp(28px,4vw,52px)", fontWeight: 900, margin: "0 0 12px", letterSpacing: -1 }}>
            Past Champions
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p style={{ color: T.gray2, fontSize: 14, lineHeight: 1.7, marginBottom: 40 }}>
            Honoring the teams who have defined excellence at SCI-COM across the years.
          </p>
        </Reveal>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {HALL.map((h, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div style={{
                background: T.bgCard, border: `1px solid ${T.borderDim}`,
                borderRadius: 6, padding: "18px 20px",
                borderLeft: `3px solid ${h.award === "Grand Champion" ? T.blue : T.gray3}`,
              }}>
                <div className="hof-row">
                  <span style={{ fontFamily: T.mono, fontSize: 11, color: T.gray2, minWidth: 36, flexShrink: 0 }}>{h.year}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: T.white, fontWeight: 700, fontSize: "clamp(14px,1.5vw,16px)" }}>{h.winner}</div>
                    <div style={{ color: T.gray2, fontSize: 12, fontFamily: T.mono, marginTop: 2 }}>{h.team} · {h.cat}</div>
                  </div>
                  <div className="hof-badge" style={{
                    background: h.award === "Grand Champion" ? "rgba(59,130,246,0.12)" : "rgba(42,51,72,0.5)",
                    border: `1px solid ${h.award === "Grand Champion" ? "rgba(59,130,246,0.3)" : T.gray3}`,
                    borderRadius: 3, padding: "4px 12px", flexShrink: 0,
                    fontFamily: T.mono, fontSize: 9,
                    color: h.award === "Grand Champion" ? T.blue : T.gray2,
                    letterSpacing: 1, textTransform: "uppercase", whiteSpace: "nowrap",
                  }}>{h.award}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
